import { mdiMapMarker } from "@mdi/js";
import Icon from "@mdi/react";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { _serverUrl2 } from "../../../config";
import useQuery from "../../../Hooks/useQuery";
import { zoomToFeatureByGeojson } from "../../Map/Layers/TempLayer";

export default function KullaniciDetay() {
  const query = useQuery();
  const today = new Date().toISOString().split("T")[0];
  const [tarih, setTarih] = useState(query.get("tarih") || today);
  const [data, setData] = useState({
    personelCalismaTurler: [{ label: "Bekleniyor", val: "0" }],
  });
  const [veri, setVeri] = useState([]);
  const history = useHistory();
  const kullanici = useParams().id;

  const getInfosFromNode = useCallback(async () => {
    await axios.post(_serverUrl2 + "/statics/personelCalismaBilgileri", { duzenleme_tarihi: tarih, kullanici_adi: kullanici }).then((res) => {
      setData({ personelCalismaTurler: res.data.rows });
    });
    await axios.post(_serverUrl2 + "/statics/PersonelBilgi", { kullanici_adi: kullanici }).then((res) => {
      setVeri(res.data.rows[0]);
    });
  }, [tarih, kullanici]);

  useEffect(() => {
    getInfosFromNode();
  }, [getInfosFromNode]);

  return (
    <div className="row" style={{ justifyContent: "center" }}>
      <div className="col-sm-4" style={{ flexDirection: "column", minWidth: "200px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="col-sm-12">
          <div className="textBox">
            <div className="content d-flex justify-content-between">
              <button className="orangeBtn" style={{ fontSize: "13px", width: "30px" }} onClick={() => history.goBack()}>
                <i className="fas fa-arrow-left"></i>
              </button>
              <b>{kullanici} Profili</b>
              <b>&nbsp;</b>
            </div>
          </div>
        </div>

        <div className="col-sm-12 textBox">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-sm-12">
                  <div className="textBox">
                    <div className="header">Kullanıcıya Bilgileri</div>
                    <div className="content d-flex d-inline">
                      <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
                        <tbody>
                          <tr>
                            <th>Kullanıcı Adı</th>
                            <td>{veri.kullanici_adi}</td>
                          </tr>
                          <tr>
                            <th>Ad Soyad</th>
                            <td>{veri.isim_soyisim}</td>
                          </tr>
                          <tr>
                            <th>Telefon Numarası</th>
                            <td>--</td>
                          </tr>
                          <tr>
                            <th>Ekibi</th>
                            <td>Ekibi Yok</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-sm-12 textBox">
          <div className="row">
            <div className="col-12 textBox">
              <input type="date" onChange={(e) => setTarih(e.target.value)} value={tarih} className="form-control"></input>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-sm-12">
                  <div className="textBox">
                    <div className="header">Kullanıcıya Ait Son İşlemler</div>
                    <div className="content d-flex d-inline" style={{ maxHeight: "575px" }}>
                      <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
                        <thead>
                          <tr>
                            <th>Konum</th>
                            <th>Tip</th>
                            <th>Adı</th>
                            <th>Düzenleme İçeriği</th>
                            <td>Düzenleme Tarihi</td>
                            <td></td>
                          </tr>
                        </thead>
                        <tbody>
                          {data.personelCalismaTurler.map((d, i) => {
                            return (
                              <tr key={i}>
                                <td style={{ borderLeft: "3px solid rgb(160, 202, 140)" }} onClick={() => zoomToFeatureByGeojson(d.geojson)}>
                                  <Icon path={mdiMapMarker} size={1.5} style={{ color: "#344e75", cursor: "pointer" }} />
                                </td>
                                <td>{d.tip_text}</td>
                                <td>{d.adi}</td>
                                <td style={{ textAlign: "start" }}>{d.duzenleme_icerigi}</td>
                                <td>{d.trh}</td>
                                <td>
                                  <button
                                    style={{ width: "30px" }}
                                    className="greenBtn"
                                    onClick={() => {
                                      d.tip == 2 || d.tip == 5
                                        ? history.push("/dashboard/hsign/update/" + d.duzenleme_yapilan)
                                        : history.push("/dashboard/sign/update/" + d.duzenleme_yapilan);
                                    }}
                                  >
                                    <i className="fas fa-folder-open"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
